import { render, staticRenderFns } from "./PanelChat.vue?vue&type=template&id=30115c66&scoped=true&"
import script from "./PanelChat.vue?vue&type=script&lang=js&"
export * from "./PanelChat.vue?vue&type=script&lang=js&"
import style0 from "./PanelChat.vue?vue&type=style&index=0&id=30115c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30115c66",
  null
  
)

export default component.exports